import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=a0b23496&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=a0b23496&prod&lang=css"
import style1 from "./OrderDetail.vue?vue&type=style&index=1&id=a0b23496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b23496",
  null
  
)

export default component.exports